import React from 'react'
import { Input, Popup } from 'components/UIElements'
import { PW_REQUIREMENTS } from 'utils/misc'
import PropTypes from 'prop-types'

const ChangePasswordForm = ({ updateNewPassword, changePassword }) => {
  return (
    <div className='change-password-form'>
      <div className='change-password-header'>
        <h4>Change Your Password</h4>
        <Popup
          hover
          position='top'
          trigger={<i className='clickable fa fa-info-circle' />}>
          <div>
            {PW_REQUIREMENTS.map((req, idx) => {
              return <p key={idx}>{req}</p>
            })}
          </div>
        </Popup>
      </div>
      <Input
        label='Old Password'
        onChange={value => updateNewPassword('oldPassword', value)}
        value={changePassword.oldPassword}
        type='password'
      />
      <Input
        label='New Password'
        onChange={value => updateNewPassword('newPassword1', value)}
        value={changePassword.newPassword1}
        type='password'
      />
      <Input
        label='Confirm New Password'
        onChange={value => updateNewPassword('newPassword2', value)}
        value={changePassword.newPassword2}
        type='password'
      />
    </div>
  )
}

ChangePasswordForm.propTypes = {
  updateNewPassword: PropTypes.func
}

export default ChangePasswordForm
